import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            用户热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            看看大家都在聊什么，加入讨论吧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {commentItems.slice(0, 3).map((comment) => (
            <div
              key={comment.id}
              className="p-5 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-label text-sm font-bold text-primary-700">
                    {comment.avatar}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-heading text-sm font-semibold text-foreground-900">
                    {comment.user}
                  </div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}

          {commentItems.slice(3).map((comment) => (
            <div
              key={comment.id}
              className="hidden lg:block p-5 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-label text-sm font-bold text-secondary-700">
                    {comment.avatar}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-heading text-sm font-semibold text-foreground-900">
                    {comment.user}
                  </div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}